import {
  HHChip,
  HHFormControlLabel,
  HHStack,
  HHSwitch,
  HHTypography,
} from '@hinge-health/react-component-library';

interface ValidationSummaryBarProps {
  successCount: number;
  errorCount: number;
  hideSuccessful: boolean;
  onToggleHideSuccessful: (checked: boolean) => void;
}

export const ValidationSummaryBar = ({
  successCount,
  errorCount,
  hideSuccessful,
  onToggleHideSuccessful,
}: ValidationSummaryBarProps): JSX.Element => (
  <HHStack
    direction="row"
    spacing={2}
    alignItems="center"
    justifyContent="space-between"
  >
    <HHStack direction="row" spacing={1} alignItems="center">
      <HHTypography hhVariant="body2">Validation Results:</HHTypography>
      <HHChip
        hhVariant="outlined"
        label={`${successCount} passed`}
        color="success"
        size="small"
      />
      {errorCount > 0 && (
        <HHChip
          hhVariant="outlined"
          label={`${errorCount} failed`}
          color="error"
          size="small"
        />
      )}
    </HHStack>
    {successCount > 0 && errorCount > 0 && (
      <HHFormControlLabel
        control={
          <HHSwitch
            hhVariant="primary"
            checked={hideSuccessful}
            onChange={(_, checked): void => onToggleHideSuccessful(checked)}
            size="small"
          />
        }
        label="Hide successful validations"
      />
    )}
  </HHStack>
);
